import React, { Component } from "react";
import { Select, Form, Button, Tooltip, Icon, Input } from "antd";

const { Option } = Select;
const InputGroup = Input.Group;
class ChangeRegionalDatabaseForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedDb: this.props.seoDb,
      disableButton: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.seoDb !== this.props.seoDb) {
      this.setState({ selectedDb: this.props.seoDb });
    }
  }

  handleChange = (seoDb) => {
    this.setState({ selectedDb: seoDb,
                    disableButton: false});
  };
  handleSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.selectedDb);
  };

  render() {
    return (
      <Form
        layout="vertical"
        onSubmit={this.handleSubmit}
        className={this.props.customClassName}
        style={{ padding: 20 }}>
        {this.props.customClassName === "dashboard-settings-change-regional-db-form" ? (
          <p>
            <strong>Regional database{" "}</strong>
            <Tooltip
              title={
                "Please select the location of your primary target audience - our keyword tracking tool will retrieve region specific data from the appropriate keyword database"
              }>
              <Icon type="question-circle" />
            </Tooltip>
          </p>
        ) : (
          <p>
            Please select the location of your primary target audience - our keyword tracking tool will retrieve region
            specific data from the appropriate keyword database
          </p>
        )}

        <Form.Item>
          <InputGroup compact size="large">
            <div className="compact-input-group">
              <Select value={this.state.selectedDb} onChange={this.handleChange} size="large">
                {this.props.regionalDatabases &&
                  Object.keys(this.props.regionalDatabases).map((regional_db) => (
                    <Option key={regional_db} data-cy="change-db-select-option" value={regional_db}>
                      {regional_db} - {this.props.regionalDatabases[regional_db]}
                    </Option>
                  ))}
              </Select>
              <Button type="primary" htmlType="submit" loading={this.props.isChangingSeoDb} size="large" disabled={this.state.disableButton}>
                {this.props.customClassName === "dashboard-settings-change-regional-db-form"
                  ? "Apply"
                  : "Change"}
              </Button>
            </div>
          </InputGroup>
        </Form.Item>
      </Form>
    );
  }
}

export default ChangeRegionalDatabaseForm;
